/**
 * Grant Negotiation Lesson
 * Skill Area: Leadership
 * Secure funding terms with strategic advocacy
 */

import type { LessonDefinition } from '../types';
import { GRANT_NEGOTIATION_AI_PROMPT } from '../prompts/grant-negotiation.prompt';

export const grantNegotiation: LessonDefinition = {
  id: 'grant-negotiation',
  title: 'Grant Negotiation',
  displayTitle: 'Secure Funding Terms with Strategic Advocacy',
  subTitle: 'Practice high-stakes advocacy vs. a tough stakeholder.',
  tagline: 'Advocate for your needs without losing the relationship.',
  persona: 'Lyra',
  skillArea: 'Leadership',
  format: 'scenario',
  difficulty: 'Advanced',
  estimatedMinutes: 8,
  tags: ['negotiation', 'funding', 'advocacy'],
  dailyEligible: false,
  releasedAt: '2025-03-01T00:00:00.000Z',
  route: '/micro/grant-negotiation',
  storyBeat: 'Lyra helps you practice the hard conversations safely.',
  learningMode: 'negotiation',
  introPrompt:
    "High-stakes funder conversations can make or break your relationship—and your funding. One wrong move and the trust you've built evaporates. Let's practice.",
  steps: [
    "Identify the conversation you've been dreading",
    "Understand your funder's perspective and priorities",
    'Practice the conversation with realistic objections',
    'Debrief and build your approach for the real meeting',
  ],
  promptGuidance: 'Describe the funder conversation you need to have.',
  aiPrompt: GRANT_NEGOTIATION_AI_PROMPT,
  inputPlaceholder: 'e.g., Asking for expanded grant scope...',
  quickPrompts: [
    'Grant renewal negotiation',
    'Budget modification request',
    'Timeline extension ask',
    'Scope change discussion',
  ],
};
